export const SET_SETTINGS = "setSettings";
export const SET_VISIBILITY = "setVisibility";
